function updateEmptyParagraphsWithClass(newClassName) {
  const pTags = document.querySelectorAll('.article-template__content p');
  pTags.forEach(p => {
    if (p.innerHTML.trim() === '&nbsp;') {
      p.classList.add(newClassName);
    }
  });
}
updateEmptyParagraphsWithClass('only-nbsp-inside');



let headlines = document.querySelectorAll('h1,.article-template__content h2,.article-template__content h3');
const h1 = document.querySelectorAll('h1').length;
const h2 = document.querySelectorAll('.article-template__content h2').length;
const h3 = document.querySelectorAll('.article-template__content h3').length;
headlines = Array.from(headlines).filter(headline => headline.innerText != '');

const generateNestedList = (headlines) => {
  const stack = [];
  const root = { children: [] };

  let currentLevel = 0;
  let currentNode = root;

  headlines.forEach((headline) => {
    const level = parseInt(headline.tag.substring(1), 10);
    const newNode = { ...headline, children: [] };

    if (level > currentLevel) {
      stack.push(currentNode);
      currentNode.children.push(newNode);
      currentNode = newNode;
    } else if (level === currentLevel) {
      stack[stack.length - 1].children.push(newNode);
      currentNode = newNode;
    } else {
      console.log('stack = ', stack)
      console.log('tag = ', stack[stack.length - 1].tag)
      if( stack[stack.length - 1] && stack[stack.length - 1].tag ) {
        while (stack.length > 0 && stack[stack.length - 1] && stack[stack.length - 1].tag && (parseInt(stack[stack.length - 1].tag.substring(1), 10)) >= level) {
          currentNode = stack.pop();
        }
      }
      stack[stack.length - 1].children.push(newNode);
      currentNode = newNode;
    }

    currentLevel = level;
  });

  return root.children;
}

window.scrolling = false;
const scrollToElement = (name) => {
  if( !window.scrolling ) {
    window.scrolling = true;
    offset = -20;
    // var elementPosition = element.getBoundingClientRect().top;
    const elementIndex = Array.from(headlines).findIndex(headline => headline.innerText == name);
    let newHeadlines = document.querySelectorAll('h1,.article-template__content h2,.article-template__content h3');
    newHeadlines = Array.from(newHeadlines).filter(headline => headline.innerText != '');
    const elementPosition = newHeadlines[elementIndex].getBoundingClientRect().top
    window.scrollTo(0, elementPosition + offset + window.pageYOffset);

    setTimeout(() => {
      window.scrolling = false;
    },100)
  }

  /*
  if( !found.classList.includes('clicked') ) {
  }
  document.querySelector('[data-headline-name="'+name+'"]').classList.add('clicked')
  setTimeout(() => {
    found.classList.remove('clicked');
  }, 500)
  */
}

const generateHtmlList = (items) => {
  let html = '<ul>';

  items.forEach((item, index) => {
    if( item.name ) {
      // data-headline-name="'${item.name.replaceAll(' ', '-').replaceAll(/[&\/\\#,+()$~%.'":*?<>{}]/g,'-').toLowerCase()}'"
      html += `<li onclick="scrollToElement('${item.name}')">`;
      // html += `<a href="#${(item.name).toLowerCase().replaceAll(' ', '-').replace(/[&\/\\#,+()$~%.'":*?<>{}]/g,'')}">`;
      html += `${item.name}`;
      if (item.children.length > 0) {
        html += generateHtmlList(item.children);
      }
      // html += '</a>';
      html += '</li>';
    }
  });

  html += '</ul>';
  return html;
}

let list = [];
headlines.forEach((h) => { 
  const name = h.innerText;
  const tag = h.nodeName;
  list.push({tag,name})
})

const nestedHeadlines = generateNestedList(list);
const htmlList = generateHtmlList(nestedHeadlines);

const articleContentRepleced = document.querySelector('.article-template').innerHTML.replaceAll('[NMH-SHORTCODE-INTRODUCTION]', `<div class="nmh-introduction">
    <div class="nmh-introduction-container">
        <span>What is included in this article:</span>
        <div class="nmh-introduction-list">
        </div>
    </div>
</div>`);

document.querySelector('.article-template').innerHTML = articleContentRepleced;
/*
const nmhIntroductionList = document.querySelector('.nmh-introduction-list');
nmhIntroductionList.innerHTML = htmlList;
nmhIntroductionList.querySelector('ul ul')
nmhIntroductionList.innerHTML = '<ul>' + nmhIntroductionList.querySelector('ul ul').innerHTML + '</ul>';
*/
/*
const nmhIntroductionLists = document.querySelectorAll('.nmh-introduction-list');
nmhIntroductionLists.forEach(nmhIntroductionList => {
  nmhIntroductionList.innerHTML = htmlList;
  nmhIntroductionList.querySelector('ul ul')
  nmhIntroductionList.innerHTML = '<ul>' + nmhIntroductionList.querySelector('ul ul').innerHTML + '</ul>';
})
*/
const nmhIntroductionLists = document.querySelectorAll('.nmh-introduction-list');
nmhIntroductionLists.forEach(nmhIntroductionList => {
  nmhIntroductionList.innerHTML = htmlList;
  nmhIntroductionList.querySelector('ul ul')
  nmhIntroductionList.innerHTML = '<ul>' + nmhIntroductionList.querySelector('ul ul').innerHTML + '</ul>';
})

/*
[NMH-SHORTCODE-INTRODUCTION]
[NMH-SHORTCODE-BUTTON title="Test" href="/"]
*/

//.replace(/[NMH-SHORTCODE-BUTTON.*]/, '')
const content = document.querySelector('.article-template').innerHTML;
const mySubString = content.substring(
    content.indexOf("[NMH-SHORTCODE-BUTTON") + 1, 
    content.lastIndexOf("]")
);

var getFromBetween = {
    results:[],
    string:"",
    getFromBetween:function (sub1,sub2) {
        if(this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
        var SP = this.string.indexOf(sub1)+sub1.length;
        var string1 = this.string.substr(0,SP);
        var string2 = this.string.substr(SP);
        var TP = string1.length + string2.indexOf(sub2);
        return this.string.substring(SP,TP);
    },
    removeFromBetween:function (sub1,sub2) {
        if(this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return false;
        var removal = sub1+this.getFromBetween(sub1,sub2)+sub2;
        this.string = this.string.replace(removal,"");
    },
    getAllResults:function (sub1,sub2) {
        // first check to see if we do have both substrings
        if(this.string.indexOf(sub1) < 0 || this.string.indexOf(sub2) < 0) return;

        // find one result
        var result = this.getFromBetween(sub1,sub2);
        // push it to the results array
        this.results.push(result);
        // remove the most recently found one from the string
        this.removeFromBetween(sub1,sub2);

        // if there's more substrings
        if(this.string.indexOf(sub1) > -1 && this.string.indexOf(sub2) > -1) {
            this.getAllResults(sub1,sub2);
        }
        else return;
    },
    get:function (string,sub1,sub2) {
        this.results = [];
        this.string = string;
        this.getAllResults(sub1,sub2);
        return this.results;
    }
};


const parseShortcode = (shortcode) => {
  const attributePattern = /(\w+)=["']([^"']+)["']/g;
  const attributes = {};
  let match;

  while ((match = attributePattern.exec(shortcode)) !== null) {
    const key = match[1].replace(/-([a-z])/g, (g) => g[1].toUpperCase());
    let value = match[2];

    // If value is a number, convert it to a number type
    if (!isNaN(value) && !isNaN(parseFloat(value))) {
      value = parseFloat(value);
    }

    attributes[key] = value;
  }

  return attributes;
}

function htmlDecode(input){
  var e = document.createElement('div');
  e.innerHTML = input;
  return e.childNodes[0].nodeValue;
}

var shortcodes = getFromBetween.get(content,"[NMH-SHORTCODE","[/NMH-SHORTCODE]");
shortcodes.forEach((shortcode) => {
    
  // Example usage:
  const shortcodeString = '[NMH-SHORTCODE' + shortcode + '[/NMH-SHORTCODE]';
  const attrJson = parseShortcode(shortcodeString);
  
  /*const attribues = shortcode.split(' ').filter(s => s).map(s => s.endsWith(']') ? s.slice(0, -1) : s);
  let attrJson = {};
  attribues.forEach((attribute) => {
    const key = attribute.split('=')[0];
    let value = attribute.split('=')[1];

    if( value.startsWith('"') ) {
      value = value.substring(1);
    }
    if( value.endsWith('"') ) {
      value = value.slice(0, -1);
    }
    attrJson[key] = value;
  })*/

  let output = '';
  if( attrJson.type == 'button' ) {
    output = `<a href="${attrJson.href}" class="nmh-dynamic-button">
        <div class="nmh-dynamic-button-container">
            <div>
              <div>${htmlDecode(attrJson.title)}</div>
              <svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18" fill="none">
                <path d="M20.711 9.44155C20.7642 9.37745 20.8105 9.3083 20.8492 9.23516C20.9472 9.0598 20.999 8.86383 21 8.66455C20.998 8.5059 20.9639 8.34916 20.8995 8.2032L20.8241 8.06966C20.792 8.00588 20.7542 7.94494 20.711 7.88754L14.429 0.603134C14.3234 0.48037 14.1938 0.378903 14.0476 0.304531C13.9014 0.23016 13.7415 0.18434 13.577 0.169686C13.4125 0.155029 13.2467 0.171827 13.0889 0.219116C12.9311 0.266407 12.7845 0.343266 12.6574 0.445303C12.5304 0.547341 12.4254 0.67256 12.3484 0.813809C12.2715 0.955059 12.224 1.10957 12.2089 1.26853C12.1937 1.42749 12.2111 1.58778 12.26 1.74025C12.309 1.89272 12.3885 2.03438 12.4941 2.15714L17.0549 7.45048L1.25641 7.45048C0.92319 7.45048 0.603617 7.57839 0.367994 7.80607C0.132372 8.03376 1.05201e-07 8.34256 1.01362e-07 8.66455C9.75218e-08 8.98654 0.132372 9.29534 0.367994 9.52303C0.603617 9.75071 0.92319 9.87862 1.25641 9.87862L17.0674 9.87862L12.4941 15.172C12.2808 15.4199 12.1782 15.7395 12.2089 16.0606C12.2395 16.3816 12.4009 16.6777 12.6574 16.8838C12.914 17.0899 13.2448 17.189 13.577 17.1594C13.9093 17.1298 14.2157 16.9739 14.429 16.726L20.711 9.44155Z" fill="#1C495A"/>
              </svg>
            </div>
        </div>
    </a>`
  }

  let replaceString = '<p>[NMH-SHORTCODE' + shortcode + '[/NMH-SHORTCODE]</p>';
  if( !document.querySelector('.article-template').innerHTML.includes(replaceString) ) {
    replaceString = '[NMH-SHORTCODE' + shortcode + '[/NMH-SHORTCODE]';
  }
  
  const shortcodeReplacement = document.querySelector('.article-template').innerHTML.replaceAll(replaceString, output);
  document.querySelector('.article-template').innerHTML = shortcodeReplacement;

})

document.querySelectorAll('.nmh-dynamic-button').forEach(ndb => {
  if( ndb.children.length == 0 ) {
    ndb.remove();
  }
})


function swapParentChild(parent, childClass) {
  // const parent = document.querySelector(`.${parentClass}`);
  const child = parent.querySelector(`.${childClass}`);
  if( !child ) return;
  
  const childClone = child.cloneNode(true);
  childClone.innerHTML = parent.outerHTML;

  return parent.replaceWith(childClone);
}


document.querySelectorAll('.nmh-dynamic-button-container').forEach(ndb => {
  swapParentChild(ndb, 'nmh-dynamic-button');
})

document.querySelectorAll('.nmh-dynamic-button').forEach(ndb => {
  if( ndb.querySelector('.nmh-dynamic-button') ) {
    ndb.querySelector('.nmh-dynamic-button').outerHTML = ndb.querySelector('.nmh-dynamic-button').innerHTML;
  }
})




/*
const articleContentRepleced = document.querySelector('.article-template').innerHTML.replaceAll('[NMH-SHORTCODE-INTRODUCTION]', `<div class="nmh-introduction">
    <div class="nmh-introduction-container">
        <span>What is included in this article:</span>
        <div class="nmh-introduction-list">
        </div>
    </div>
</div>`);
*/